import React, { useEffect, useState, useRef } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { countyOptions } from 'config/constants/Constants';

// Use a taller aspect ratio and ensure the SVG fits the container
const useStyles = makeStyles(() => ({
  svgContainer: {
    width: '100%',
    height: '700px', // Increased height for full SVG visibility
    overflow: 'auto', // Allow scrolling if needed
    '& svg': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      display: 'block',
      viewBox: '0 0 800 1000', // Ensure the SVG viewBox is respected if present
    },
    '& svg path': {
      transition: 'fill 0.3s',
      fill: '#e0e0e0',
      stroke: '#888',
    },
  },
}));

// Use your primary green here
const PRIMARY_GREEN = '#229626';


function CountiesMap({ counties = [] }) {
  const classes = useStyles();
  const svgRef = useRef();
  const [svgRaw, setSvgRaw] = useState('');

  // Compute the list of counties to highlight
  let highlightCounties = counties;
  if (counties.includes('All')) {
    highlightCounties = countyOptions.map(c => c.value);
  }

  // Load the SVG file on mount
  useEffect(() => {
    fetch('counties.svg')
      .then((res) => res.text())
      .then(setSvgRaw)
      .catch(console.error);
  }, []);

  // Highlight paths based on title attribute
  useEffect(() => {
    const svgElement = svgRef.current?.querySelector('svg');
    if (!svgElement) return;

    svgElement.removeAttribute('width');
    svgElement.removeAttribute('height');
    // Optionally set a viewBox if missing
    if (!svgElement.getAttribute('viewBox')) {
      svgElement.setAttribute('viewBox', '0 0 800 1000');
    }

    const paths = svgElement.querySelectorAll('path');

    paths.forEach((path) => {
      const titleAttr = path.getAttribute('title')?.trim();
      const isSelected = titleAttr && highlightCounties.includes(titleAttr);
      path.style.fill = isSelected ? PRIMARY_GREEN : '#e0e0e0';
    });
  }, [counties, svgRaw]);

  return (
    <Box className={classes.svgContainer} ref={svgRef} dangerouslySetInnerHTML={{ __html: svgRaw }}>
    </Box>
  );
}

export default CountiesMap;
